import TagManager from 'react-gtm-module';
import { getConfig } from '../utils/config';

const GTM_ID = getConfig().gtmId;
export const GTMService = {
  init: () => {
    if (import.meta.env.DEV) {
      console.log('[GTM] init skipped in dev mode!');
      return;
    }
    console.log('[GTM] init service');
    TagManager.initialize({ gtmId: GTM_ID });
  },
};
